import React from "react";
import { handleLinkify } from '../../utils'
import moment from 'moment'
import "./answeredComment.css";
import { injectIntl } from "react-intl";
import AttachIcon from "./AttachIcon";

const AnsweredComment = (props) => {
    const { answeredComment, intl } = props;
    const userName = answeredComment.user_creator.name
    const formattedTime = moment(answeredComment.createdAt).fromNow()
    const handledLinkyfy = handleLinkify(answeredComment.comment.slice(0, 144) + '...')
    return (
        <div className="answered-comment" style={{ cursor: 'pointer' }}>
            <div className="answered-comment styled-border"></div>
            <div className="answered-comment-wrapper-info">
                <div className="answered-comment-header ">
                    <span className="text">
                        {intl.formatMessage({ id: "commented_by" }, { user_name: userName, formatted_time: formattedTime })}
                    </span>
                </div>

                <div className="answered-comment-comment ">
                    <div className="comment">
                        <p>{handledLinkyfy}</p>
                    </div>
                </div>

            </div>

            {answeredComment.attachedFile &&
                <div className="attached-icon">
                    <AttachIcon />

                </div>
            }
        </div>
    );
};
export default injectIntl(AnsweredComment);